import { AsyncPropSelector, AppContext } from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import InvoiceBuilderContext from '@nile/client_management/src/Contexts/InvoiceBuilderContext';
import { cloneDeep } from 'lodash';
import { Popover, TextField, Checkbox } from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import React, { useCallback, useState, useContext, useEffect } from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
  ${({ alignRight }) =>
    alignRight &&
    `
    width: 100%;
    justify-content: flex-end;
  `}
`;

function InvoiceItemSelectionCell(props) {
  const invoiceContext = useContext(InvoiceBuilderContext);
  const { cell } = props;
  const meta = cell.row.original;
  const {
    records,
    selectedSection,
    setSelectedRecords,
    setRecordsForMultipleSections
  } = invoiceContext;
  const getItemSelectionState = () => {
    let isSelected = -1;
    // todo refactor using boolean
    // null check is added for filter case
    if (selectedSection === 'all' || !selectedSection) {
      isSelected = records.all?.findIndex((el) => el.itemId === meta.itemId);
      isSelected = isSelected >= 0 ? isSelected : -1;
      if (isSelected === -1) {
        isSelected = records[meta?.category?.name]?.findIndex(
          (el) => el.itemId === meta.itemId
        );
        isSelected = isSelected >= 0 ? isSelected : -1;
      }
    } else {
      isSelected = records[selectedSection]?.findIndex(
        (el) => el.itemId === meta.itemId
      );
      isSelected = isSelected >= 0 ? isSelected : -1;
      if (isSelected === -1) {
        isSelected = records.all?.findIndex((el) => el.itemId === meta.itemId);
        isSelected = isSelected >= 0 ? isSelected : -1;
      }
    }
    return isSelected > -1;
  };
  const [selected, setSelected] = useState(getItemSelectionState());
  const columnData = cell.column;

  /**
   *
   * We maitain only one record for checked/unchecked across categories (all, particular)
   * So adding to particular section and removing from whichever section it is present (even if we unselect from all/particular).
   */
  const handleSelection = (checked, metaData) => {
    if (checked) {
      setSelected(checked);
      const selectedSectionItem = selectedSection || 'all';
      const newRecords = cloneDeep(records[selectedSectionItem]) || [];
      newRecords.push(metaData);
      setSelectedRecords(newRecords);
    } else {
      setSelected(checked);
      const selectedSectionItem = selectedSection || 'all';
      let newRecords = cloneDeep(records[selectedSectionItem]) || [];
      const index = newRecords.findIndex((el) => el.itemId === metaData.itemId);
      if (index < 0) {
        if (selectedSection === 'all' || !selectedSection) {
          newRecords = cloneDeep(records[meta.category.name]) || [];
          const itemInCategoryIndex = newRecords.findIndex(
            (el) => el.itemId === metaData.itemId
          );
          newRecords.splice(itemInCategoryIndex, 1);
          setRecordsForMultipleSections({
            [meta.category.name]: newRecords
          });
        } else {
          newRecords = cloneDeep(records.all) || [];
          const itemInCategoryIndex = newRecords.findIndex(
            (el) => el.itemId === metaData.itemId
          );
          newRecords.splice(itemInCategoryIndex, 1);
          setRecordsForMultipleSections({
            all: newRecords
          });
        }
      } else {
        newRecords.splice(index, 1);
        setSelectedRecords(newRecords);
      }
    }
  };
  useEffect(() => {
    const newSelected = getItemSelectionState();
    setSelected(newSelected);
  }, [meta?.itemId]);
  useEffect(() => {
    const newSelected = getItemSelectionState();
    setSelected(newSelected);
  }, [records?.audit, records]);

  return (
    <Wrap className={`cell`}>
      <Checkbox
        checked={selected}
        onChange={(checked) => {
          handleSelection(checked, meta);
          setSelected(checked);
        }}
        name="item-selection"
        id={`item-${meta?.itemId}`}
      />
    </Wrap>
  );
}

export default InvoiceItemSelectionCell;
